import React, { useEffect, useState } from 'react';
import { Checkbox, TextInput } from '@mantine/core';

import useUpdateCheckList from '../hooks/useUpdateChecklist';
import useDeleteTaskChecklist from '../hooks/useDeleteTaskChecklist';

import { ReactComponent as DeleteIcon } from 'assets/icons/deleteIcon2.svg';

export default function CheckListItem({ item, selectedTaskDataId }) {
  const [editChecklistValue, setEditChecklistValue] = useState('');

  const updateChecklistMutation = useUpdateCheckList(selectedTaskDataId);
  const deleteChecklistMutation = useDeleteTaskChecklist(selectedTaskDataId);

  const handleCheckListEdit = (e) => {
    e.preventDefault();
    updateChecklistMutation.mutate({
      id: item?.id,
      task_id: selectedTaskDataId,
      checklist: editChecklistValue,
    });
  };

  useEffect(() => {
    setEditChecklistValue(item?.checklist);
  }, [item]);

  return (
    <div>
      <form onSubmit={(e) => handleCheckListEdit(e)}>
        <div className='flex items-center justify-between mr-5 hover:bg-FFE8E1 px-2 rounded-lg'>
          <div className='flex items-center'>
            <Checkbox
              checked={item?.is_completed}
              onChange={(e) =>
                updateChecklistMutation.mutate({
                  id: item?.id,
                  task_id: selectedTaskDataId,
                  is_completed: e.currentTarget.checked,
                })
              }
              classNames={{
                input: 'rounded-full',
              }}
            />
            <TextInput
              value={editChecklistValue}
              onChange={(e) => setEditChecklistValue(e.target.value)}
              placeholder='Add an item'
              classNames={{
                input: `${
                  item?.is_completed ? 'line-through' : ''
                } border-none bg-transparent`,
              }}
            />
          </div>
          <div className='flex items-center'>
            <DeleteIcon
              className='w-5 cursor-pointer'
              onClick={() => deleteChecklistMutation.mutate({ id: item?.id })}
            />
          </div>
        </div>
      </form>
    </div>
  );
}
